(function () {
    let liveSearch,
        siteHeaderNav,
        searchInput,
        dimmer,
        searchDesktop,
        searchMobileBtn;

    function initCache() {
        liveSearch = document.querySelector('.live-search');
        siteHeaderNav = document.querySelector('#site-header-nav');
        searchInput = document.querySelector('.live-search-form-field');
        dimmer = document.querySelector('.site-main-dimmer');
        searchDesktop = document.querySelector('.search-btn-desktop');
        searchMobileBtn = document.querySelector('.site-header-mobile-search-button');
    }

    window.openSearch = function (ev) {
        document.body.classList.add('search-is-open');
        if (!liveSearch) liveSearch = document.querySelector('.live-search');
        if (liveSearch) liveSearch.style.display = 'block';

        if (siteHeaderNav) {
            siteHeaderNav.style.display = 'none';
            if (searchInput) searchInput.focus();
        }

        if (dimmer) {
            dimmer.style.display = 'block';
            dimmer.style.opacity = 1;
        }
    };

    window.closeSearch = function () {
        document.body.classList.remove('search-is-open');
        if (liveSearch) liveSearch.style.display = 'none';
        if (siteHeaderNav) siteHeaderNav.style.display = 'block';

        if (searchInput) {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('input', { bubbles: true }));
            searchInput.dispatchEvent(new Event('keyup', { bubbles: true }));
        }

        if (dimmer) {
            dimmer.style.display = 'none';
            dimmer.style.opacity = 0;
        }
    };

    window.handleClearSearch = function () {
        if (searchInput && searchInput.value.trim().length > 0) {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('input', { bubbles: true }));
            searchInput.dispatchEvent(new Event('keyup', { bubbles: true }));
            searchInput.focus();
        } else {
            closeSearch();
        }
    };

    window.checkClickOutOfSearchBar = function (event) {
        if (!liveSearch || !searchDesktop) return;

        const clickedInside = liveSearch.contains(event.target) ||
            searchDesktop.contains(event.target) ||
            (searchMobileBtn && searchMobileBtn.contains(event.target));

        if (!clickedInside) {
            closeSearch();
        }
    };

    document.addEventListener('DOMContentLoaded', function () {
        initCache();
        document.addEventListener('click', window.checkClickOutOfSearchBar);
    });
})();